import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dateModal", "dateTitle", "dateBookings"];

  disconnect() {
    this.requestController?.abort();
  }

  async openDate(event) {
    const { calendarUrl: url, calendarLabel: label } = event.currentTarget.dataset;
    if (!url || !this.hasDateModalTarget || !this.hasDateBookingsTarget) return;

    this.requestController?.abort();
    const requestController = new AbortController();
    this.requestController = requestController;
    if (this.hasDateTitleTarget) this.dateTitleTarget.textContent = `${label} 的预订`;
    this.dateBookingsTarget.textContent = "正在加载预订记录…";
    this.dateBookingsTarget.setAttribute("aria-busy", "true");
    this.dateModalTarget.showModal();

    try {
      const response = await fetch(url, {
        headers: { Accept: "text/html" },
        signal: requestController.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const html = await response.text();
      if (this.requestController !== requestController) return;
      this.dateBookingsTarget.innerHTML = html;
    } catch (error) {
      if (error.name !== "AbortError" && this.requestController === requestController) {
        this.dateBookingsTarget.textContent = "加载预订记录失败，请稍后重试。";
      }
    } finally {
      if (this.requestController === requestController) this.dateBookingsTarget.removeAttribute("aria-busy");
    }
  }
}
